export const companyStats = {
  capital: 127500,
  reputation: 72,
  creditScore: 85,
  activeProjects: 4,
  pendingTasks: 7,
};

export const capitalChartData = [
  { day: "월", capital: 98000, income: 12000, expense: 5000 },
  { day: "화", capital: 105000, income: 15000, expense: 8000 },
  { day: "수", capital: 101000, income: 5000, expense: 9000 },
  { day: "목", capital: 113000, income: 18000, expense: 6000 },
  { day: "금", capital: 121000, income: 14000, expense: 6000 },
  { day: "토", capital: 124000, income: 8000, expense: 5000 },
  { day: "일", capital: 127500, income: 6000, expense: 2500 },
];

export const reputationHistory = [
  { week: "3주전", score: 58 },
  { week: "2주전", score: 63 },
  { week: "지난주", score: 68 },
  { week: "이번주", score: 72 },
];

export const projects = [
  {
    id: "p1",
    title: "루나&스타즈 1st EP 제작",
    progress: 75,
    deadline: "2026.04.10",
    budget: 45000,
    spent: 33750,
    status: "진행중",
    members: ["A&R", "마케팅"],
  },
  {
    id: "p2",
    title: "DarkNova 뮤직비디오 프로젝트",
    progress: 40,
    deadline: "2026.04.25",
    budget: 80000,
    spent: 32000,
    status: "진행중",
    members: ["제작", "법무"],
  },
  {
    id: "p3",
    title: "봄 시즌 디지털 싱글 캠페인",
    progress: 90,
    deadline: "2026.03.31",
    budget: 20000,
    spent: 18000,
    status: "마감임박",
    members: ["마케팅"],
  },
  {
    id: "p4",
    title: "신인 아티스트 발굴 오디션",
    progress: 20,
    deadline: "2026.05.15",
    budget: 15000,
    spent: 3000,
    status: "초기",
    members: ["A&R"],
  },
];

export const todoItems = [
  { id: "t1", text: "루나&스타즈와 계약서 2차 검토 요청 메일 회신", done: false, priority: "high" },
  { id: "t2", text: "DarkNova MV 예산안 재무팀에 전자결재 제출", done: false, priority: "high" },
  { id: "t3", text: "봄 시즌 싱글 SNS 홍보 카피 초안 작성", done: true, priority: "medium" },
  { id: "t4", text: "외주 디자이너 YoonArt에 발주서 발송 확인", done: false, priority: "medium" },
  { id: "t5", text: "가상 음원차트 주간 보고서 취합", done: true, priority: "low" },
  { id: "t6", text: "법무팀 독소조항 검토 완료 여부 확인", done: false, priority: "high" },
  { id: "t7", text: "신인 오디션 지원자 1차 서류 검토", done: false, priority: "low" },
];

export const randomEvents = [
  {
    id: "e1",
    type: "crisis",
    title: "⚠️ 긴급 위기 발생",
    headline: "아티스트 DarkNova의 2년 전 SNS 발언 논란",
    description:
      "DarkNova의 2024년 인스타그램 게시물에서 특정 발언이 문제가 되어 실시간 검색어 1위에 올랐습니다. 팬 커뮤니티와 언론이 공식 입장을 요구하고 있습니다.",
    impact: { reputation: -15, capital: -2000 },
    actions: [
      { label: "즉시 공식 사과문 작성", result: { reputation: -5, capital: 0 } },
      { label: "AI 언론사에 해명 보도자료 배포", result: { reputation: -3, capital: -500 } },
      { label: "침묵 유지 (위험)", result: { reputation: -20, capital: -5000 } },
    ],
  },
  {
    id: "e2",
    type: "opportunity",
    title: "🚀 기회 포착!",
    headline: "루나&스타즈 숏폼 영상 바이럴 급상승",
    description:
      "루나&스타즈의 티저 클립이 틱톡에서 48시간 만에 조회수 230만을 돌파했습니다. 현재 음원 차트 급상승 중이며, 대형 음원 플랫폼에서 피처드 제안이 들어왔습니다.",
    impact: { reputation: +12, capital: +8000 },
    actions: [
      { label: "피처드 제안 즉시 수락 + 홍보 강화", result: { reputation: +15, capital: +12000 } },
      { label: "신중하게 조건 협상 후 진행", result: { reputation: +10, capital: +8000 } },
      { label: "자체 채널 독립 운영", result: { reputation: +8, capital: +5000 } },
    ],
  },
  {
    id: "e3",
    type: "crisis",
    title: "⚠️ 긴급 공문 수신",
    headline: "경쟁사 '스타라이트 엔터'로부터 표절 시비 내용증명 도착",
    description:
      "스타라이트 엔터가 DarkNova의 신곡 멜로디가 자사 소속 아티스트의 미발매곡과 유사하다며 법적 조치를 예고했습니다. 법무팀 즉각 대응이 필요합니다.",
    impact: { reputation: -10, capital: -3000 },
    actions: [
      { label: "법무팀에 즉시 검토 의뢰", result: { reputation: -5, capital: -1000 } },
      { label: "상대측에 협의 요청 메일 발송", result: { reputation: -3, capital: -500 } },
      { label: "공식 반박문 언론 배포", result: { reputation: -8, capital: -2000 } },
    ],
  },
  {
    id: "e4",
    type: "opportunity",
    title: "🎪 긴급 섭외 요청",
    headline: "대형 K-POP 페스티벌 대타 출연 제안",
    description:
      "오는 주말 코엑스 K-POP 페스티벌에서 메인 출연사가 갑자기 불참을 통보했습니다. 주최측이 루나&스타즈에게 긴급 대타 출연을 제안했습니다. 출연료 2,500만원 즉시 계약.",
    impact: { reputation: +20, capital: +25000 },
    actions: [
      { label: "즉시 수락 (리허설 없이 강행)", result: { reputation: +15, capital: +25000 } },
      { label: "최소 조건 협상 후 수락", result: { reputation: +20, capital: +25000 } },
      { label: "준비 부족으로 정중히 거절", result: { reputation: +5, capital: 0 } },
    ],
  },
  {
    id: "e5",
    type: "crisis",
    title: "⚠️ 내부 유출 사고",
    headline: "루나&스타즈 미발매곡 음원 파일 온라인 유출",
    description:
      "발매 예정이었던 루나&스타즈의 타이틀곡 원본 파일이 익명 커뮤니티에 유포되었습니다. 발매 전략 전면 수정이 불가피하며, 법무팀 조사 착수가 필요합니다.",
    impact: { reputation: -18, capital: -4000 },
    actions: [
      { label: "발매일 즉시 앞당기기 (긴급 발매)", result: { reputation: -5, capital: +3000 } },
      { label: "법무팀에 유출 경위 조사 의뢰", result: { reputation: -10, capital: -2000 } },
      { label: "팬들에게 공식 편지 발행 + 특별 선물", result: { reputation: -3, capital: -1000 } },
    ],
  },
  {
    id: "e6",
    type: "opportunity",
    title: "📺 방송 출연 제안",
    headline: "음악방송 '뮤직뱅크' 메인 무대 출연 확정",
    description:
      "KBS 음악방송 프로그램에서 루나&스타즈의 신곡 뮤직뱅크 메인 무대 출연을 제안했습니다. 방영일은 2주 뒤이며, 무대 준비에 추가 예산이 필요합니다.",
    impact: { reputation: +18, capital: +15000 },
    actions: [
      { label: "수락 + 퍼포먼스 팀 긴급 편성", result: { reputation: +20, capital: +15000 } },
      { label: "수락 + 기존 안무로 진행 (예산 절감)", result: { reputation: +15, capital: +15000 } },
      { label: "일정 맞지 않아 정중히 거절", result: { reputation: 0, capital: 0 } },
    ],
  },
  {
    id: "e7",
    type: "crisis",
    title: "⚠️ 녹음실 정전 사고",
    headline: "스튜디오 정전으로 DarkNova 앨범 녹음 일정 3주 지연",
    description:
      "전속 계약된 녹음 스튜디오에서 대규모 전기 합선 사고가 발생했습니다. 복구까지 최소 3주가 소요되며, 앨범 발매 일정 전면 조정이 불가피합니다.",
    impact: { reputation: -8, capital: -5000 },
    actions: [
      { label: "타 스튜디오 긴급 대관 (고비용)", result: { reputation: 0, capital: -8000 } },
      { label: "발매 일정 3주 연기 공지", result: { reputation: -10, capital: 0 } },
      { label: "홈 레코딩 장비 임시 구매", result: { reputation: -5, capital: -3000 } },
    ],
  },
  {
    id: "e8",
    type: "opportunity",
    title: "💰 투자 유치 기회",
    headline: "벤처캐피털 '케이팝파트너스'가 지분 투자 제안",
    description:
      "국내 엔터테인먼트 전문 VC인 케이팝파트너스가 K-ArtPEN에 5억원 규모 시드 투자를 제안했습니다. 단, 경영권의 30%를 요구합니다.",
    impact: { reputation: +10, capital: +50000 },
    actions: [
      { label: "투자 수락 (경영권 30% 양보)", result: { reputation: +10, capital: +50000 } },
      { label: "지분 20%로 재협상 시도", result: { reputation: +5, capital: +30000 } },
      { label: "독립 경영 유지 위해 거절", result: { reputation: +8, capital: 0 } },
    ],
  },
  {
    id: "e9",
    type: "crisis",
    title: "⚠️ 세무조사 통보",
    headline: "국세청 가상 세무조사 통보 수신",
    description:
      "가상 국세청으로부터 최근 2년간 법인세 신고 내역 세무조사 통보가 도착했습니다. 재무팀의 즉각적인 서류 준비와 대응이 필요합니다.",
    impact: { reputation: -12, capital: -8000 },
    actions: [
      { label: "외부 세무사 긴급 선임", result: { reputation: -5, capital: -2000 } },
      { label: "재무팀 자체 소명자료 준비", result: { reputation: -8, capital: -500 } },
      { label: "세무조사 일정 연기 신청", result: { reputation: -12, capital: -1000 } },
    ],
  },
  {
    id: "e10",
    type: "opportunity",
    title: "🌏 글로벌 기회",
    headline: "일본 대형 레이블과 공동 앨범 제작 협업 제안",
    description:
      "일본 3대 레이블 중 하나인 소니뮤직재팬이 루나&스타즈의 일본어 버전 앨범 공동 제작을 제안했습니다. 글로벌 진출의 발판이 될 수 있습니다.",
    impact: { reputation: +25, capital: +30000 },
    actions: [
      { label: "즉시 협업 수락 + 일본 진출 착수", result: { reputation: +25, capital: +30000 } },
      { label: "세부 조건 검토 후 협상", result: { reputation: +20, capital: +25000 } },
      { label: "국내 시장 안정화 후 진출 결정", result: { reputation: +5, capital: 0 } },
    ],
  },
  {
    id: "e11",
    type: "crisis",
    title: "⚠️ 팬덤 갈등",
    headline: "루나&스타즈 팬덤 내부 갈등으로 온라인 폭발",
    description:
      "공식 팬덤 내부에서 멤버 개인 활동 관련 갈등이 폭발, 트위터에서 해시태그 분쟁이 발생했습니다. 여론이 급속도로 악화되고 있습니다.",
    impact: { reputation: -12, capital: -1000 },
    actions: [
      { label: "아티스트 직접 팬 소통 라이브 진행", result: { reputation: +5, capital: -500 } },
      { label: "공식 입장문 발표 + 팬 이벤트 기획", result: { reputation: 0, capital: -1500 } },
      { label: "잠시 모니터링 후 자연스럽게 진정 대기", result: { reputation: -15, capital: 0 } },
    ],
  },
  {
    id: "e12",
    type: "opportunity",
    title: "🎬 콘텐츠 제안",
    headline: "넷플릭스 코리아 K-POP 다큐멘터리 출연 제안",
    description:
      "넷플릭스 코리아가 신인 아이돌의 성장 과정을 담는 오리지널 다큐멘터리 시리즈에 루나&스타즈를 주인공으로 캐스팅 제안했습니다.",
    impact: { reputation: +30, capital: +20000 },
    actions: [
      { label: "전면 수락 + 풀 제작 지원", result: { reputation: +30, capital: +20000 } },
      { label: "음악 활동 방해 없는 조건으로 협상", result: { reputation: +22, capital: +15000 } },
      { label: "아직 이르다고 판단, 정중히 거절", result: { reputation: +5, capital: 0 } },
    ],
  },
];

export const recentActivities = [
  { id: "a1", time: "09:15", text: "유통사 담당자 김과장으로부터 계약 수수료 재협상 메일 수신", type: "mail" },
  { id: "a2", time: "09:45", text: "DarkNova MV 예산안 전자결재 승인 완료", type: "approval" },
  { id: "a3", time: "11:20", text: "외주 디자이너 YoonArt 앨범 커버 시안 1차 발송", type: "mail" },
  { id: "a4", time: "13:05", text: "봄 시즌 싱글 음원차트 진입 (+47위)", type: "chart" },
  { id: "a5", time: "14:30", text: "광고주 서울전자로부터 뮤직비디오 협찬 변경 요청 수신", type: "mail" },
];
